<patron-toolbar>
  <div class="flex justify-content-end">
    <patron-button class="pr-2" iconName="bi-check-lg" [loading]="loadingSave" (click)="save()">
      Salvar
    </patron-button>
  </div>
</patron-toolbar>
<div class="col-12 py-0">
  <div class="card">
    <div class="card-body">
      <patron-form [formGroup]="formGroup">
        <div class="row">
          <div class="col-lg-6 py-0">
            <patron-select
              [formGroup]="formGroup"
              formControlName="company"
              placeholder="Selecione a empresa"
              bindLabel="_name"
              orderBy="ref"
              label="Empresa *"
              modelName="companies">
            </patron-select>
            <patron-select
              [formGroup]="formGroup"
              formControlName="customer"
              placeholder="Selecione o cliente"
              bindLabel="_name"
              orderBy="persons.ref"
              label="Cliente *"
              modelName="customers">
            </patron-select>

            <div class="mx-1">
              <div class="row">
                <div class="col-6 py-0">
                  <patron-select
                    [formGroup]="formGroup"
                    formControlName="system"
                    placeholder="Selecione o sistema"
                    bindLabel="description"
                    orderBy="ref"
                    label="Sistema *"
                    modelName="systems">
                  </patron-select>
                </div>
                <div class="col-6 py-0">
                  <patron-select
                    [formGroup]="formGroup"
                    formControlName="status"
                    orderBy="ref"
                    placeholder="Status"
                    bindLabel="description"
                    label="Status *"
                    modelName="ticket-statuses">
                  </patron-select>
                </div>
              </div>
            </div>

            <patron-select
              [formGroup]="formGroup"
              formControlName="userResp"
              placeholder="Responsável"
              bindLabel="_name"
              orderBy="ref"
              label="Responsável *"
              modelName="users">
            </patron-select>
            <patron-select
              [formGroup]="formGroup"
              formControlName="userDes"
              placeholder="Desenvolvedor"
              bindLabel="_name"
              orderBy="ref"
              label="Desenvolvedor"
              modelName="users">
            </patron-select>
            <patron-textarea
              [formGroup]="formGroup"
              formControlName="summary"
              label="Resumo"
              rows="2">
            </patron-textarea>
            <patron-textarea
              [formGroup]="formGroup"
              formControlName="problem"
              label="Problema *"
              rows="8">
            </patron-textarea>
          </div>
          <div class="col-lg-6 py-0">
            <div class="row">
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="type"
                  [items]="types"
                  placeholder="Tipo"
                  bindLabel="label"
                  label="Tipo">
                </patron-select>
              </div>
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="ticketType"
                  placeholder="Tipo chamada"
                  bindLabel="description"
                  orderBy="ref"
                  label="Tipo chamada"
                  modelName="ticket-types">
                </patron-select>
              </div>
            </div>

            <div class="row">
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="phase"
                  placeholder="Selecione a fase"
                  bindLabel="description"
                  orderBy="ref"
                  label="Fase"
                  modelName="phases">
                </patron-select>
              </div>
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="issue"
                  placeholder="Assunto"
                  bindLabel="description"
                  orderBy="ref"
                  label="Assunto"
                  modelName="issues">
                </patron-select>
              </div>
            </div>

            <div class="row">
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="project"
                  placeholder="Projeto"
                  bindLabel="description"
                  orderBy="ref"
                  label="Projeto"
                  modelName="projects">
                </patron-select>
              </div>
              <div class="col-6 py-0">
                <patron-select
                  [formGroup]="formGroup"
                  formControlName="sprint"
                  placeholder="Sprint"
                  bindLabel="description"
                  orderBy="ref"
                  label="Sprint"
                  modelName="sprints">
                </patron-select>
              </div>
            </div>

            <div class="row">
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="requester"
                  label="Solicitante">
                </patron-form-field>
              </div>
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="phone"
                  placeholder="(xx) x xxxx-xxxx"
                  label="Telefone"
                  type="mask"
                  mask="(00) 0 0000-0000||(00) 0000-0000||(00) 000-0000">
                </patron-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="email"
                  placeholder="E-mail"
                  label="E-mail">
                </patron-form-field>
              </div>
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="priority"
                  placeholder="Prioridade"
                  label="Prioridade">
                </patron-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="estimatedEffort"
                  placeholder="Esforço Técnico"
                  label="Esforço Técnico">
                </patron-form-field>
              </div>
              <div class="col-6 py-0">
                <patron-form-field
                  [formGroup]="formGroup"
                  formControlName="commercialEstimatedEffort"
                  placeholder="Esforço Comercial"
                  label="Esforço Comercial">
                </patron-form-field>
              </div>
            </div>
            <div class="row">
              <!-- <div style="border: 2px solid brown;"> -->
              <div class="col-12 py-0">
                <patron-form-chips [formGroup]="formGroup" formControlName="tags" label="Tags">
                </patron-form-chips>
              </div>
              <div class="col-12 py-0">
                <app-ticket-documents
                  [entity]="ticket"
                  [uploadPath]="'tickets/new/' + idTemp"
                  (saving)="loadingSave = $event"></app-ticket-documents>
              </div>
            </div>
          </div>
        </div>
      </patron-form>
    </div>
  </div>
</div>
